/**
 * CliInstallStrip — extracted from Landing.js (Feb 14 2026)
 * Single-line CLI install pitch: terminal icon, npm install command, link to /cli docs.
 * Pure presentational, no state.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Terminal, ArrowRight } from 'lucide-react';

export default function CliInstallStrip() {
  return (
    <section className="py-10 px-4 border-t border-white/5" data-testid="cli-install-strip">
      <div className="max-w-5xl mx-auto rounded-2xl border border-emerald-500/20 bg-slate-900 px-5 py-5 sm:px-7 sm:py-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-7">
          <div className="flex items-center gap-3 shrink-0">
            <div className="w-11 h-11 rounded-xl bg-emerald-500 shadow-lg shadow-emerald-500/40 flex items-center justify-center">
              <Terminal className="w-5 h-5 text-white drop-shadow-[0_0_4px_rgba(255,255,255,0.55)]" />
            </div>
            <div className="leading-tight">
              <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-emerald-300">CARTIE in your terminal</div>
              <div className="text-sm font-bold text-white">CLI &amp; MCP server · live on npm</div>
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <code
              className="block w-full text-sm font-mono text-emerald-200 bg-slate-950/60 border border-emerald-500/20 rounded-lg px-4 py-2.5 overflow-x-auto"
              data-testid="cli-install-strip-cmd"
            >
              <span className="text-slate-500 select-none">$</span> npm install -g @cartieai/cli
            </code>
            <p className="text-[11px] text-slate-400 mt-1.5">
              Plugs into Claude Desktop &amp; Cursor as an MCP server. Ask <span className="font-mono text-emerald-300">cartie why</span> for any cost spike.
            </p>
          </div>
          <Link
            to="/cli"
            data-testid="cli-install-strip-cta"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-300 hover:text-emerald-200 shrink-0"
          >
            Read CLI docs <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
